import script from "./agreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./agreement.vue?vue&type=script&lang=ts&setup=true"

import "./agreement.vue?vue&type=style&index=0&id=445cecaa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-445cecaa"]])

export default __exports__